export default theme => ({
    header: {
        flex: '0 0 auto',
        boxSizing: 'border-box',
        height: theme.height.topBar,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.border}`,
    },
    // Equal-width side zones flanking the title. Each grows from a 0 basis, so
    // they always match regardless of how many buttons they hold — which keeps
    // the title centered on the whole header, not on the leftover space. No
    // minWidth override here: the zones keep their button width as a shrink floor,
    // so a long title runs out of room and ellipsizes (via the title's minWidth: 0)
    // instead of collapsing the zones and overlapping the buttons.
    leftZone: {
        flex: '1 1 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: theme.spacing(1),
    },
    rightZone: {
        flex: '1 1 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
    },
    iconButton: {
        flex: '0 0 auto',
        minWidth: 0,
    },
    title: {
        flex: '0 1 auto',
        minWidth: 0,
        textAlign: 'center',
        fontWeight: 600,
    },
    chatActions: {
        flex: '0 0 auto',
    },
    viewSwitcher: {
        flex: '0 0 auto',
    },
    close: {
        flex: '0 0 auto',
    },
    viewMenuHeading: {
        lineHeight: 2,
        textTransform: 'uppercase',
        fontSize: theme.typography.pxToRem(11),
        fontWeight: 600,
        letterSpacing: '0.08em',
        color: theme.palette.text.secondary,
    },
    viewCheck: {
        marginLeft: theme.spacing(2),
        color: theme.palette.primary.main,
    },
});
